import { library } from '@fortawesome/fontawesome-svg-core';
import {
    faBell,
    faAngleRight,
    faAngleLeft,
    faAngleDown,
    faAngleUp,
    faPowerOff,
    faUser,
    faCircleInfo,
    faFileCsv,
    faCircleXmark,
    faSpinner,
    faTriangleExclamation,
    faCodeBranch,
    faRotate,
    faCheck,
    faXmark,
    faPause,
    faPlay,
    faArrowLeft,
    faRotateLeft,
    faArrowUpRightFromSquare,
    faBolt,
    faCircleQuestion,
    faClock,
    faGlobe,
    faLink,
    faListUl,
    faMagnifyingGlass,
    faArrowRight,
    faCircle,
    faCloud,
    faDatabase,
    faGear,
    faLayerGroup,
    faRightToBracket,
    faSkull,
    faBan,
    faBroom,
    faArrowDown,
    faCircleCheck,
    faCircleExclamation,
    faCloudArrowDown,
    faBoxArchive,
    faSort,
    faSortDown,
    faSortUp,
    faFilter,
    faCopy,
    faEnvelope,
    faFileCode,
    faHourglassHalf,
    faInbox,
    faRocket,
    faLightbulb,
    faMinus,
    faPaperPlane,
    faTable,
    faExclamation,
    faFlask,
    faFileArrowUp,
    faTrashCan,
    faCircleStop,
    faFileInvoice,
    faBuildingColumns,
    faReceipt,
    faRobot,
    faScaleBalanced,
    faArrowRightLong,
    faArrowLeftLong,
    faHandHoldingDollar,
} from '@fortawesome/free-solid-svg-icons';

export const initFontAwesome = () => {
    library.add(faAngleRight);

    // The lane from Exact back to Chargebee runs right to left.
    library.add(faAngleLeft);
    library.add(faAngleDown);
    library.add(faAngleUp);
    library.add(faUser);
    library.add(faPowerOff);
    library.add(faCircleInfo);
    library.add(faFileCsv);
    library.add(faCircleXmark);
    library.add(faSpinner);
    library.add(faTriangleExclamation);
    library.add(faCodeBranch);
    library.add(faRotate);
    library.add(faCheck);
    library.add(faXmark);
    library.add(faPause);
    library.add(faPlay);
    library.add(faArrowLeft);
    library.add(faRotateLeft);
    library.add(faArrowUpRightFromSquare);

    // The pipeline badges: a state per app, a trigger type per function, and the ways out
    // to Azure.
    library.add(faBolt);
    library.add(faCircleQuestion);
    library.add(faClock);
    library.add(faGlobe);
    library.add(faLink);
    library.add(faListUl);
    library.add(faMagnifyingGlass);

    // The stations of an object trace: a kind of station per icon, plus the dot that marks
    // a step of the search that has not run yet.
    library.add(faArrowRight);
    library.add(faCircle);
    library.add(faCloud);
    library.add(faDatabase);
    library.add(faGear);
    library.add(faLayerGroup);
    library.add(faRightToBracket);
    library.add(faSkull);

    // The way back that is ruled out, next to the ones that are not.
    library.add(faBan);
    library.add(faBroom);

    /*
        The visual language of the object trace: what a station is, what state it is in, and
        what travels between two of them.

        A kind per shape and a state per badge, because a chain of ten steps that all look
        alike is a chain nobody reads at a glance - and the things that travel get their own
        icons too, since "queuebericht" and "opgeslagen body" are the two halves a reader is
        forever trying to keep apart.
    */
    library.add(faArrowDown);
    library.add(faCircleCheck);
    library.add(faCircleExclamation);
    library.add(faCloudArrowDown);
    library.add(faCopy);
    library.add(faEnvelope);
    library.add(faFileCode);
    library.add(faHourglassHalf);
    library.add(faInbox);
    library.add(faRocket);
    library.add(faLightbulb);
    library.add(faMinus);
    library.add(faPaperPlane);
    library.add(faTable);

    // The alerts in the header.
    library.add(faBell);

    // Closing an issue that no longer matters.
    library.add(faBoxArchive);

    // Sortable columns.
    library.add(faSort, faSortDown, faSortUp);
    library.add(faFilter);
    // The scenario tests: the badge on the way in when the last run failed, and the mark of a suite.
    library.add(faExclamation);
    library.add(faFlask);

    // Managing the suites themselves: uploading one, and deleting one.
    library.add(faFileArrowUp);
    library.add(faTrashCan);

    // Stopping a run that is going.
    library.add(faCircleStop);

    // The money flow of an invoice: what happened in Chargebee, in Exact, and what the connector carried across.
    library.add(faFileInvoice, faBuildingColumns, faReceipt, faRobot, faScaleBalanced, faArrowRightLong, faArrowLeftLong, faHandHoldingDollar);
};
